export const OptInCopy = {
  updateEmployeeChoices:
    'Only press "Complete" on a commuter choice if you have taken action according to the commuter choice. If you wish to ignore a commuter choice, press "Ignore".',
  mobileConfirmEmployeeChoiceDisclaimer:
    'Press the checkmark if you have taken action according to the commuter choice or press the X if you wish to ignore the commuter choice.',
}
